import React from "react";
import { Provider } from "react-redux";
import { Route, Router } from "react-router-dom";
import EmptyPage from "./modules/core/empty";
import history from "shared/plugins/history";
import { Loading } from "shared/components/loading/loading";
import { store } from "app.store";
import { Appointment } from "modules/appointment/appointment";
import "./themes/css/main.css";
import "font-awesome/css/font-awesome.min.css";
import { ModalComponent } from "shared/components/modal/modal-confirm";
if (process.env.NODE_ENV === "development") {
  require("./themes/css/variables.css");
}

function App() {
  return (
    <Provider store={store}>
      <Router history={history}>
        {process.env.NODE_ENV === "development" && (
          <meta
            name="viewport"
            content="width=device-width, initial-scale=1, shrink-to-fit=no,maximum-scale=1, user-scalable=no"
          ></meta>
        )}
        <Route exact path="/booking" component={Appointment} />
        <Route path="/booking/empty" exact={true} component={EmptyPage} />
        <Loading />
        <ModalComponent></ModalComponent>
      </Router>
    </Provider>
  );
}

export default App;
